import getPrimaryTabConversationId from './getPrimaryTabConversationId';
import clearReadingPaneStore from '../actions/clearReadingPaneStore';
import loadConversationReadingPane from '../actions/loadConversationReadingPane';
import loadItemReadingPane from '../actions/loadItemReadingPane';
import setItemReadingPaneViewState from '../actions/setItemReadingPaneViewState';
import readingPaneStore from '../store/Store';
import { findInlineComposeViewState, lazyTrySaveAndCloseCompose } from 'owa-mail-compose-actions';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import {
    registerTabHandler,
    TabHandler,
    TabType,
    SecondaryReadingPaneTabViewState,
} from 'owa-tab-store';

const secondaryReadingPaneTabHandler: TabHandler = {
    onActivate: (viewState: SecondaryReadingPaneTabViewState) => {
        const secondaryReadingPaneTabData = viewState.data;

        switch (secondaryReadingPaneTabData.listViewType) {
            case ReactListViewType.Conversation:
                loadConversationReadingPane(
                    secondaryReadingPaneTabData.id,
                    secondaryReadingPaneTabData.instrumentationContext,
                    secondaryReadingPaneTabData.subject
                );
                break;
            case ReactListViewType.Message:
                loadItemReadingPane(
                    secondaryReadingPaneTabData.id,
                    secondaryReadingPaneTabData.instrumentationContext,
                    setItemReadingPaneViewState
                );
                break;
        }
    },
    canClose: async (viewState: SecondaryReadingPaneTabViewState) => {
        const secondaryReadingPaneTabData = viewState.data;
        switch (secondaryReadingPaneTabData.listViewType) {
            case ReactListViewType.Conversation:
                try {
                    const conversationId =
                        readingPaneStore.conversationReadingPaneViewState.conversationId.Id;

                    // When this tab is showing the same conversation with primary tab, always allow close
                    if (conversationId == getPrimaryTabConversationId()) {
                        return true;
                    }

                    const composeViewState = findInlineComposeViewState(conversationId);
                    if (composeViewState) {
                        await lazyTrySaveAndCloseCompose.importAndExecute(composeViewState);
                        return !findInlineComposeViewState(conversationId);
                    }
                    return true;
                } catch (e) {
                    // In case of any errors in obtaining conversation view state, always allow close
                    return true;
                }
            case ReactListViewType.Message:
            default:
                return true;
        }
    },
    onDeactivate: (viewState: SecondaryReadingPaneTabViewState) => {
        const secondaryReadingPaneTabData = viewState.data;
        // The default ReadingPane render is based on the contents of the store.
        // In scenarios like the drafts folder, switching items renders the default RP content.
        // This is often times whatever item was previously in the store for this value.
        // We null the store's content so that this does not happen.
        clearReadingPaneStore(secondaryReadingPaneTabData.listViewType);
    },
};

export default function ensureSecondaryReadingPaneTabHandler() {
    registerTabHandler(TabType.SecondaryReadingPane, secondaryReadingPaneTabHandler);
}
